import Immutable from 'immutable';
import { SET_SUGGESTIONS, CLEAR_SUGGESTIONS } from './actions';
import { LOGOUT_SUCCESS } from '../../Auth/actions';

const INITIAL_STATE = Immutable.Map();
/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function UserSuggest(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_SUGGESTIONS:
    case CLEAR_SUGGESTIONS: {
      const users = Immutable.fromJS(action.users);
      let newState = state;
      let suggestions = Immutable.List();
      users.forEach((user) => {
        suggestions = suggestions.push(user);
      });
      newState = newState.set('list', suggestions);
      return newState;
    }
    case LOGOUT_SUCCESS: {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
}
